import { IconHelpCircle } from 'featherico';
import moment from 'moment-timezone';
import api from '../../../../../api';
import { Dropdown, OptionLink, OptionWithModal, createLinkOption } from '../../../../components/Dropdown';
import NotificationsDotButton from '../../../../components/Notifications/Dot/Button';
import NotificationsDotInline from '../../../../components/Notifications/Dot/Inline';
import { useAppContext } from '../../../../hooks/useAppContext';
import { useObservable } from '../../../../hooks/useObservable';
import { isFeatureEnabled } from '../../../../services/Features';
import { isAnyAdmin } from '../../../../services/User';
import IntercomSupportLink from '../../../Navigation/SupportLink/IntercomSupportLink';
import { HrListSupport } from '../../../Navigation/SupportLink/WithHrListSupportModal';

const OptionHelpLink = createLinkOption((props: { onClick?: () => void }) => (
    <IntercomSupportLink inHeader={true} {...props} />
));

export default function HelpMenu() {
    const { user: currentUser } = useAppContext();

    const { value: lastUpdatedReleaseNotes } = useObservable(
        () => api.releaseNotes.getLastUpdatedReleaseNotes.createObservable(),
        []
    );

    const newReleaseNotes =
        lastUpdatedReleaseNotes &&
        moment(currentUser.lastCheckedReleaseNotes ?? currentUser.dateCreated).isBefore(lastUpdatedReleaseNotes?.date);

    return (
        <Dropdown
            buttonClass="headerIconButton"
            kind="PLAIN"
            showChevron={false}
            ariaLabel={`Help menu`}
            label={
                <>
                    <IconHelpCircle />
                    {newReleaseNotes && <NotificationsDotButton />}
                </>
            }
            eventTracking={{ category: 'navigation header help', action: 'toggle' }}
            large={true}
            className={isFeatureEnabled('FEATURE_layoutRefresh') && 'top-aligned left-aligned'}
        >
            <OptionLink
                href="https://intercomdocs.small-improvements.com/en/"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'help center' }}
            >
                Help Center
            </OptionLink>
            {isAnyAdmin(currentUser) ? (
                <OptionHelpLink />
            ) : (
                <OptionWithModal
                    modalProps={{
                        size: 'LG_WIDTH',
                        title: 'Get Help',
                        body: () => <HrListSupport />,
                    }}
                    eventTracking={{
                        category: 'navigation header help',
                        action: 'click',
                        label: 'get help non-admin',
                    }}
                >
                    Get Support
                </OptionWithModal>
            )}
            <OptionLink
                href="https://www.small-improvements.com/release-notes"
                onClick={() => api.userSettings.setCheckedReleaseNotes()}
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'whats new' }}
            >
                What's New
                {newReleaseNotes && <NotificationsDotInline />}
            </OptionLink>
            <OptionLink
                href="https://status.small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'system status' }}
            >
                System Status
            </OptionLink>
            <OptionLink
                href="https://small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'si home page' }}
            >
                Website
            </OptionLink>
        </Dropdown>
    );
}
